var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTranslationsResources } from '../../hooks/useTranslationsResources';
var initialValue = {
    changeLanguage: function (_) { return console.warn('Please implement `changeLanguage`'); },
    status: 'idle',
    isIdle: true,
    isLoading: false,
    isError: false,
    isSuccess: false,
};
export var TranslationsContext = createContext(initialValue);
export var TranslationsProvider = function (_a) {
    var children = _a.children, _b = _a.getResources, getResources = _b === void 0 ? function () { return Promise.resolve({}); } : _b;
    var i18n = useTranslation().i18n;
    var _c = useTranslationsResources(getResources), status = _c.status, isIdle = _c.isIdle, isLoading = _c.isLoading, isError = _c.isError, isSuccess = _c.isSuccess, error = _c.error;
    var _d = useState(i18n.language), language = _d[0], setLanguage = _d[1];
    var changeLanguage = function (lang) {
        setLanguage(lang);
        i18n.changeLanguage(lang);
    };
    var value = {
        language: language,
        changeLanguage: changeLanguage,
        status: status,
        isIdle: isIdle,
        isLoading: isLoading,
        isError: isError,
        isSuccess: isSuccess,
        error: error,
    };
    return _jsx(TranslationsContext.Provider, __assign({ value: value }, { children: children }));
};
export function useTranslations() {
    return useContext(TranslationsContext);
}
